<template>
    <b-form-group :label="label" label-for="polarity">
        <Select
            id="polarity"
            :state="state"
            :selected="value"
            :options="polarityOptions"
            @changeValue="$emit('update:value', $event)"
            aria-describedby="polarityFeedback"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="polarityFeedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import { Select } from '@/views/components/selects'
import defaultPolarityOptions from '@/data/polarity'

export default {
    name: 'Polarity',
    components: {
        Select,
    },
    props: ['value', 'state', 'label', 'disabled'],
    data() {
        return {
            polarityOptions: defaultPolarityOptions,
        }
    },
    mounted() {
        const defaultOption = this.polarityOptions.find(
            option => option.isDefault
        )
        this.$emit('update:value', defaultOption)
    },
}
</script>
